const urls = {
  IDENTIFICATION_FAILED: 'identification-failed',
  INVALID_TOKEN: 'invalid-token',
  CHANGE_PASSWORD_FAILED: 'change-password-failed',
  INVALID_SESSION: 'invalid-session',
  PAGE_NOT_FOUND: 'page-not-found',
  REQUEST_FAILED: 'resquest-failed',
  _ALL: '**',
  _BLANK: ''
};
export const ErrorsURLs = urls;
